// extracted by mini-css-extract-plugin
module.exports = {"container":"userData_container__3WKMF","name":"userData_name__CraYd","other":"userData_other__UK2_N"};